export default {"src":"/_next/static/media/vector_4.b80ab086.svg","height":126,"width":258,"blurWidth":0,"blurHeight":0};